import { getAmplitudeInstance } from '../amplitudeHelpers';
import TrailDetailsAction from '../enums/TrailDetailsAction';
import TrailDetailsActionLocation from '../enums/TrailDetailsActionLocation';

type logTrailDetailsActionTappedParams = {
  trail_id?: string;
  trail_page_action?: TrailDetailsAction;
  trail_page_location?: TrailDetailsActionLocation;
};

/**
 * User taps a link to complete an action on the trail details page. July 2024 consolidation of Trail Details Add to Completed Clicked, Trail Details Directions Button Tapped, Trail Details Print Clicked, Share Displayed, Garmin Send Route Tapped, Trail Details OverFlowItem Selected, Trail Download Button Tapped, Save Clicked.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail page the user was on when they tapped a link to complete an action.
 * @param params.trail_page_action - The action that the user wanted to take on the trail page (i.e. the link that the user clicked).
 * @param params.trail_page_location - The trail page action link's location on the trail details page.
 */
const logTrailDetailsActionTapped = (
  { trail_id, trail_page_action, trail_page_location }: logTrailDetailsActionTappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details action tapped',
    { 'trail id': trail_id, 'trail page action': trail_page_action, 'trail page location': trail_page_location },
    callback
  );
};

export default logTrailDetailsActionTapped;
